export default __webpack_public_path__ + "static/media/a004-example3.94b69f06.jpg";